import {action, observable} from 'mobx';
import {Employee} from 'stores/employees';

class NmbrEmployee extends Employee {
  @observable errorsFromLastSync = {};
  @observable employee;

  @action merge(other) {
    super.merge(other, {
      employee: Employee
    });
  }
}

export default NmbrEmployee;
